import React from "react";
import Product from "./Product";
import "./css/bestseller.css";


function BestSeller() {
  return (
    <div className="best_seller">
      <h3 className="best_seller_title">BEST SELLERS</h3>
      <div className="best_seller_list">
        <div className="best_seller_products">
          <Product
            id="1"
            title="Besan Laddoo"
            category="box"
            image="https://cdn.shopify.com/s/files/1/0057/1706/5828/products/bandar_laddu_1.jpg?v=1594369583"
            price="90"
          />
        </div>

        <div className="best_seller_products">
          <Product
            id="2"
            title="Puri Unde"
            category="box"
            image="https://m.media-amazon.com/images/I/41hzY651KAL._AC_UL480_QL65_.jpg"
            price="96"
          />
        </div>

        <div className="best_seller_products">
          <Product
            id="10"
            title="Tengolu"
            category="box"
            image="https://5.imimg.com/data5/AP/LR/MY-4365477/mini-schezwan-chakli-250x250.jpg"
            price="72"
          />
        </div>

        <div className="best_seller_products">
          <Product
            id="8"
            title="Nippattu"
            category="box"
            image="https://m.media-amazon.com/images/I/61IJJ+JrXXL._AC_UL480_QL65_.jpg"
            price="48"
          />
        </div>
      </div>
    </div>
  );
}

export default BestSeller;
